// angular
import { Component, OnInit, ViewChild, ChangeDetectorRef, Input, AfterViewInit, SimpleChanges } from '@angular/core';

// others
import { DynamicReportService } from './dynamic-report.service';
import { AppService } from '../../../../app.service';
import { AuthService } from '../../../../core/auth.service';
import { Router } from '@angular/router';
import { BaseService } from '../../../../shared/base.service';
import { TranslateService } from '@ngx-translate/core';
import { DynamicReportModel } from './dynamic-report.model';
import { FormBuilder } from '@angular/forms';
import { ClinicsService } from '../../../../clinics/clinics.service';
import { UsersService } from '../../../../users/users.service';
import { HomeService } from '../../../home.service';
import { MaintenanceService } from '../../../../maintenance/maintenance.service';
import { SecureApi } from '../../../../core/secure.api';
import {CoreService} from "../../../../core/core.service";
import {B2CAdminComponent} from "../../b2c-admin.component";
import {MaintenanceComponent} from "../../../../maintenance/maintenance.component";

@Component({
    selector: 'dynamic-report-component',
    templateUrl: './dynamic-report.component.html',
    providers: [DynamicReportService]
})


export class DynamicReportComponent extends B2CAdminComponent implements OnInit {

    @Input() isHome = false;
    @Input() filters;
    @Input() filterParams;

    data = [];
    currentCluster = null;
    clusters = [];
    subClusters = [];
    
    showActiveCluster = false;
    showActiveSubCluster = false;

    // define what table columns to display [column key, label, css class]
    readonly tableColumns = [
        ['name', 'FeelingName', 'col-xs-3'],
        ['sub_cluster_name', 'SubClusterName', 'col-xs-3'],
        ['cluster_name', 'ClusterName', 'col-xs-3'],
        ['count', 'Count', 'col-xs-1'],
        ['average', 'Avarage', 'col-xs-1'],
    ];

    constructor(public authService: AuthService,
        public coreService: CoreService,
        public router: Router,
        public translate: TranslateService,
        public fb: FormBuilder,
        public baseService: BaseService,
        public appService: AppService,
        public usersService: UsersService,
        public homeService: HomeService,
        public clinicService: ClinicsService,
        public maintenanceService: MaintenanceService,
        public secureApi: SecureApi,
        public maintenanceComponent: MaintenanceComponent,
        public service: DynamicReportService)  {
            super(authService, coreService, router, translate, fb, baseService, appService, usersService, homeService, clinicService, maintenanceService, secureApi, maintenanceComponent);
    }

    ngOnInit() {
        super.ngOnInit();

        this.searchInfo = new DynamicReportModel();

        this.sortedColumn = 'count';
        this.order = 'desc';
        this.orderField = ['-count'];
        this.sortIsActivated = true;

        this.coreService.className = 'fluid';
        this.itemsPerPage = 15;
        if (this.isHome) {
            this.itemsPerPage = 5;
        } else{
            return this.getItems();
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['filters'] && this.filters) {
            return this.getItems();
        }
    }

    getItems() {
        this.initPageSize(this.isHome);
        this.service.getAll(this.filters)
            .subscribe(response => {
            this.isLoading = false;
            this.items = response['items'];
            this.clusters = response['clusters'];
        });    
    }


    activeCluster(event) {
        this.getClusterData(event.id)
    }


    getClusterData(clusteruid) {
        this.service.getCluster(clusteruid, this.filters).subscribe((response) => {
           this.currentCluster = response['data'];
        })
    }

    activeSubCluster(event) {
    }
}
